import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#A7AEBE",
      "fill-rule": "evenodd",
      d: "M5 .833c.46 0 .833.373.833.834v1.666a.833.833 0 0 1-1.658.123c-.429.212-.784.69-.836 1.342a6.457 6.457 0 0 0-.006.425v.733c0 2.784 1.998 4.877 4.271 4.877 2.158 0 4.062-1.989 4.062-4.644v-.966c0-.272 0-.359-.005-.425-.052-.652-.407-1.13-.837-1.342a.834.834 0 0 1-1.657-.123V1.667a.833.833 0 1 1 1.666 0v.048c1.393.261 2.376 1.52 2.49 2.951.01.141.01.3.01.52V6.19c0 3.136-2.116 5.864-5 6.261v1.717a3.333 3.333 0 0 0 3.333 3.333h.736c.876 0 1.652-.434 2.123-1.1a3.334 3.334 0 1 1 1.775.234 4.265 4.265 0 0 1-3.898 2.533h-.736a5 5 0 0 1-5-5V12.42c-2.893-.5-5-3.276-5-6.464v-.769c0-.22 0-.38.012-.52.113-1.433 1.096-2.691 2.489-2.952v-.048c0-.46.373-.834.833-.834Zm10.833 10.834a1.667 1.667 0 1 0 0 3.333 1.667 1.667 0 0 0 0-3.333Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "Stethoscope"}) } }